import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {AuthenticationService} from '../services/authentication.service';
import {CodeService} from '../services/code.service';

export function AuthGuard(
  auth: boolean = true, code: boolean = false
): CanActivateFn {
  return (route, state) => {
    const authenticationService = inject(AuthenticationService);
    const codeService = inject(CodeService);
    const router = inject(Router);
    let codeValue = route.queryParams['code'];

    return new Promise(async (resolve, reject) => {
      if(codeValue && code){
        const codeDetails = await codeService.getCodeDetails(codeValue);
        if (codeDetails) {
          return resolve(true);
        }
      }

      let isAuthenticated = authenticationService.isAuthenticated.getValue();
      if(isAuthenticated){
        resolve(true);
      }else{
        resolve(router.createUrlTree(['/login'], {queryParams: {returnUrl: state.url}}));
      }
    });
  };
}
